var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-flex justify-content-center mb-1" },
      [
        _vm.loadingSpinner
          ? _c("b-spinner", {
              staticStyle: { width: "3rem", height: "3rem" },
              attrs: { variant: "success", span: "Spinning", block: "" },
            })
          : _vm._e(),
      ],
      1
    ),
    !_vm.loadingSpinner
      ? _c(
          "section",
          { staticClass: "invoice-preview-wrapper" },
          [
            _c(
              "b-row",
              { staticClass: "invoice-preview" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", xl: "9", md: "8" } },
                  [
                    _c("validation-observer", {
                      ref: "purchaseorder",
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var invalid = ref.invalid
                              return [
                                _c(
                                  "b-form",
                                  {
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "b-card",
                                      {
                                        staticClass: "invoice-preview-card",
                                        staticStyle: {
                                          display: "block",
                                          width: "100%",
                                        },
                                        attrs: {
                                          "no-body": "",
                                          id: "invoice-preview-card",
                                        },
                                      },
                                      [
                                        _c(
                                          "b-card-body",
                                          {
                                            staticClass: "invoice-padding pb-0",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row align-items-center mb-2",
                                              },
                                              [
                                                _c("div", {}, [_c("Logo")], 1),
                                                _c(
                                                  "div",
                                                  { staticClass: "col-9" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {},
                                                      [_c("CompanyName")],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {},
                                                      [_c("Address")],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "b-row",
                                              {
                                                staticClass:
                                                  "invoice-spacing align-items-start",
                                              },
                                              [
                                                _c(
                                                  "b-card-body",
                                                  {
                                                    staticClass:
                                                      "invoice-padding pt-0",
                                                  },
                                                  [
                                                    _c(
                                                      "b-row",
                                                      {
                                                        staticClass:
                                                          "invoice-spacing",
                                                      },
                                                      [
                                                        _c(
                                                          "b-col",
                                                          {
                                                            staticClass:
                                                              "mb-lg-1",
                                                            attrs: {
                                                              cols: "6",
                                                              xl: "6",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "h6",
                                                              {
                                                                staticClass:
                                                                  "mb-2",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Send to:*"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "validation-provider",
                                                              {
                                                                attrs: {
                                                                  rules:
                                                                    "required",
                                                                  name: "Supplier",
                                                                  vid: "supplierId",
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function (
                                                                          ref
                                                                        ) {
                                                                          var errors =
                                                                            ref.errors
                                                                          return [
                                                                            _c(
                                                                              "b-form-select",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    options:
                                                                                      _vm.optionsCustomer,
                                                                                    placeholder:
                                                                                      "select supplier",
                                                                                  },
                                                                                on: {
                                                                                  change:
                                                                                    _vm.supplierSelected,
                                                                                },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm
                                                                                        .whenSelected
                                                                                        .id,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm.whenSelected,
                                                                                          "id",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "whenSelected.id",
                                                                                  },
                                                                              }
                                                                            ),
                                                                            errors.length
                                                                              ? _c(
                                                                                  "small",
                                                                                  {
                                                                                    staticClass:
                                                                                      "text-danger",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        errors[0]
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass:
                                                      "p-0 d-flex justify-content-end",
                                                    attrs: {
                                                      cols: "12",
                                                      md: "6",
                                                      xl: "6",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invoice-number-date",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex align-items-center justify-content-md-end mb-1",
                                                          },
                                                          [
                                                            _c("h4", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.headerName
                                                                  ) +
                                                                  " #" +
                                                                  _vm._s(
                                                                    _vm.orderNumber
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex align-items-center my-2",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "title",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Issued Date: "
                                                                ),
                                                              ]
                                                            ),
                                                            _c("flat-pickr", {
                                                              staticClass:
                                                                "form-control invoice-edit-input",
                                                              model: {
                                                                value:
                                                                  _vm.issuedDate,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.issuedDate =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "issuedDate",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex align-items-center",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "title",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Due Date: "
                                                                ),
                                                              ]
                                                            ),
                                                            _c("flat-pickr", {
                                                              staticClass:
                                                                "form-control invoice-edit-input",
                                                              model: {
                                                                value:
                                                                  _vm.dueDate,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.dueDate =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "dueDate",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-card-body",
                                          { staticClass: "invoice-padding" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                ref: "form",
                                                staticClass: "repeater-form",
                                              },
                                              _vm._l(
                                                _vm.invoiceData.items,
                                                function (item, index) {
                                                  return _c(
                                                    "b-row",
                                                    {
                                                      key: index,
                                                      ref: "row",
                                                      refInFor: true,
                                                      staticClass: "pb-2",
                                                    },
                                                    [
                                                      _c(
                                                        "b-col",
                                                        {
                                                          attrs: { cols: "12" },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex border rounded",
                                                            },
                                                            [
                                                              _c(
                                                                "b-row",
                                                                {
                                                                  staticClass:
                                                                    "flex-grow-1 p-2",
                                                                },
                                                                [
                                                                  _c(
                                                                    "b-col",
                                                                    {
                                                                      attrs: {
                                                                        cols: "12",
                                                                        lg: "6",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "static-label",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Items*"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "d-flex",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "flex-grow-1 mr-1",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "validation-provider",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      rules:
                                                                                        "required",
                                                                                      name: "Item",
                                                                                      vid:
                                                                                        "Item_" +
                                                                                        index,
                                                                                    },
                                                                                  scopedSlots:
                                                                                    _vm._u(
                                                                                      [
                                                                                        {
                                                                                          key: "default",
                                                                                          fn: function (
                                                                                            ref
                                                                                          ) {
                                                                                            var errors =
                                                                                              ref.errors
                                                                                            return [
                                                                                              _c(
                                                                                                "v-select",
                                                                                                {
                                                                                                  class:
                                                                                                    [
                                                                                                      {
                                                                                                        "is-invalid":
                                                                                                          errors.length,
                                                                                                      },
                                                                                                      "item-selector-title",
                                                                                                    ],
                                                                                                  attrs:
                                                                                                    {
                                                                                                      options:
                                                                                                        _vm.optionsProduct,
                                                                                                      label:
                                                                                                        "itemTitle",
                                                                                                      dir: _vm
                                                                                                        .$store
                                                                                                        .state
                                                                                                        .appConfig
                                                                                                        .isRTL
                                                                                                        ? "rtl"
                                                                                                        : "ltr",
                                                                                                      clearable: false,
                                                                                                      searchable: true,
                                                                                                      placeholder:
                                                                                                        "Select Item",
                                                                                                    },
                                                                                                  on: {
                                                                                                    input:
                                                                                                      function (
                                                                                                        val
                                                                                                      ) {
                                                                                                        return _vm.updateItemForm(
                                                                                                          index,
                                                                                                          val
                                                                                                        )
                                                                                                      },
                                                                                                  },
                                                                                                  scopedSlots:
                                                                                                    _vm._u(
                                                                                                      [
                                                                                                        {
                                                                                                          key: "option",
                                                                                                          fn: function (
                                                                                                            ref
                                                                                                          ) {
                                                                                                            var itemTitle =
                                                                                                              ref.itemTitle
                                                                                                            var categoryName =
                                                                                                              ref.categoryName
                                                                                                            var subCategoryName =
                                                                                                              ref.subCategoryName
                                                                                                            return [
                                                                                                              _c(
                                                                                                                "div",
                                                                                                                {
                                                                                                                  staticStyle:
                                                                                                                    {
                                                                                                                      display:
                                                                                                                        "flex",
                                                                                                                      "flex-direction":
                                                                                                                        "column",
                                                                                                                    },
                                                                                                                },
                                                                                                                [
                                                                                                                  _c(
                                                                                                                    "span",
                                                                                                                    [
                                                                                                                      _vm._v(
                                                                                                                        _vm._s(
                                                                                                                          itemTitle
                                                                                                                        )
                                                                                                                      ),
                                                                                                                    ]
                                                                                                                  ),
                                                                                                                  _c(
                                                                                                                    "span",
                                                                                                                    [
                                                                                                                      _vm._v(
                                                                                                                        _vm._s(
                                                                                                                          categoryName ||
                                                                                                                            "-"
                                                                                                                        ) +
                                                                                                                          " : " +
                                                                                                                          _vm._s(
                                                                                                                            subCategoryName ||
                                                                                                                              "-"
                                                                                                                          )
                                                                                                                      ),
                                                                                                                    ]
                                                                                                                  ),
                                                                                                                ]
                                                                                                              ),
                                                                                                            ]
                                                                                                          },
                                                                                                        },
                                                                                                      ],
                                                                                                      null,
                                                                                                      true
                                                                                                    ),
                                                                                                  model:
                                                                                                    {
                                                                                                      value:
                                                                                                        item.name,
                                                                                                      callback:
                                                                                                        function (
                                                                                                          $$v
                                                                                                        ) {
                                                                                                          _vm.$set(
                                                                                                            item,
                                                                                                            "name",
                                                                                                            $$v
                                                                                                          )
                                                                                                        },
                                                                                                      expression:
                                                                                                        "item.name",
                                                                                                    },
                                                                                                }
                                                                                              ),
                                                                                              errors.length
                                                                                                ? _c(
                                                                                                    "small",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "text-danger",
                                                                                                    },
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          errors[0]
                                                                                                        )
                                                                                                      ),
                                                                                                    ]
                                                                                                  )
                                                                                                : _vm._e(),
                                                                                            ]
                                                                                          },
                                                                                        },
                                                                                      ],
                                                                                      null,
                                                                                      true
                                                                                    ),
                                                                                }
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  !_vm
                                                                    .purchaseorderId
                                                                    .hidePrice
                                                                    ? _c(
                                                                        "b-col",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              cols: "12",
                                                                              lg: "2",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "label",
                                                                            {
                                                                              staticClass:
                                                                                "static-label",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Unit Price (Rs)"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "validation-provider",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  rules:
                                                                                    "min_value:0",
                                                                                  name: "Unit Price",
                                                                                  vid:
                                                                                    "UnitPrice_" +
                                                                                    index,
                                                                                },
                                                                              scopedSlots:
                                                                                _vm._u(
                                                                                  [
                                                                                    {
                                                                                      key: "default",
                                                                                      fn: function (
                                                                                        ref
                                                                                      ) {
                                                                                        var errors =
                                                                                          ref.errors
                                                                                        return [
                                                                                          _c(
                                                                                            "b-form-input",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  type: "number",
                                                                                                },
                                                                                              on: {
                                                                                                keypress:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    return _vm.allowOnlyNumbers(
                                                                                                      $event
                                                                                                    )
                                                                                                  },
                                                                                              },
                                                                                              model:
                                                                                                {
                                                                                                  value:
                                                                                                    item.purchase,
                                                                                                  callback:
                                                                                                    function (
                                                                                                      $$v
                                                                                                    ) {
                                                                                                      _vm.$set(
                                                                                                        item,
                                                                                                        "purchase",
                                                                                                        $$v
                                                                                                      )
                                                                                                    },
                                                                                                  expression:
                                                                                                    "item.purchase",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                          errors.length
                                                                                            ? _c(
                                                                                                "small",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "text-danger",
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    _vm._s(
                                                                                                      errors[0]
                                                                                                    )
                                                                                                  ),
                                                                                                ]
                                                                                              )
                                                                                            : _vm._e(),
                                                                                        ]
                                                                                      },
                                                                                    },
                                                                                  ],
                                                                                  null,
                                                                                  true
                                                                                ),
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  _c(
                                                                    "b-col",
                                                                    {
                                                                      attrs: {
                                                                        cols: "12",
                                                                        lg: "2",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          staticClass:
                                                                            "static-label",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Qty*"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "validation-provider",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              rules:
                                                                                "required|min_value:1",
                                                                              name: "Quantity",
                                                                              vid:
                                                                                "Quantity_" +
                                                                                index,
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "default",
                                                                                  fn: function (
                                                                                    ref
                                                                                  ) {
                                                                                    var errors =
                                                                                      ref.errors
                                                                                    return [
                                                                                      _c(
                                                                                        "b-form-input",
                                                                                        {
                                                                                          on: {
                                                                                            keypress:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.allowOnlyNumbers(
                                                                                                  $event
                                                                                                )
                                                                                              },
                                                                                          },
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                item.qty,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    item,
                                                                                                    "qty",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                              expression:
                                                                                                "item.qty",
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                      errors.length
                                                                                        ? _c(
                                                                                            "small",
                                                                                            {
                                                                                              staticClass:
                                                                                                "text-danger",
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  errors[0]
                                                                                                )
                                                                                              ),
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  !_vm
                                                                    .purchaseorderId
                                                                    .hidePrice
                                                                    ? _c(
                                                                        "b-col",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              cols: "12",
                                                                              lg: "2",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "d-flex align-items-center justify-content-between",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "flex-grow-1",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "label",
                                                                                    {
                                                                                      staticClass:
                                                                                        "static-label",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "Total Price"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "p",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mb-1",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        " Rs " +
                                                                                          _vm._s(
                                                                                            isNaN(
                                                                                              item.purchase
                                                                                            ) ||
                                                                                              isNaN(
                                                                                                item.qty
                                                                                              )
                                                                                              ? "0"
                                                                                              : (
                                                                                                  item.purchase *
                                                                                                  item.qty
                                                                                                ).toFixed(
                                                                                                  2
                                                                                                )
                                                                                          ) +
                                                                                          " "
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "mt-1 mb-1",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "b-button",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      variant:
                                                                                        "danger",
                                                                                      size: "sm",
                                                                                    },
                                                                                  on: {
                                                                                    click:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.removeItem(
                                                                                          index
                                                                                        )
                                                                                      },
                                                                                  },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " Remove "
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _c(
                                                                    "b-col",
                                                                    {
                                                                      attrs: {
                                                                        cols: "12",
                                                                        lg: "12",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "d-inline d-lg-none",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Description"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "b-form-textarea",
                                                                        {
                                                                          staticClass:
                                                                            "mb-2 mb-lg-0",
                                                                          model:
                                                                            {
                                                                              value:
                                                                                item.description,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    item,
                                                                                    "description",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "item.description",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                            _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "ripple",
                                                    rawName: "v-ripple.400",
                                                    value:
                                                      "rgba(255, 255, 255, 0.15)",
                                                    expression:
                                                      "'rgba(255, 255, 255, 0.15)'",
                                                    modifiers: { 400: true },
                                                  },
                                                ],
                                                attrs: {
                                                  size: "sm",
                                                  variant: "primary",
                                                },
                                                on: {
                                                  click:
                                                    _vm.addNewItemInItemForm,
                                                },
                                              },
                                              [_vm._v(" Add Item ")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-card-body",
                                          {
                                            staticClass: "invoice-padding pb-0",
                                          },
                                          [
                                            _c(
                                              "b-row",
                                              [
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass:
                                                      "mt-md-0 mt-3 d-flex align-items-center",
                                                    attrs: {
                                                      cols: "12",
                                                      md: "4",
                                                      order: "2",
                                                      "order-md": "1",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "w-100" },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-nowrap mr-50",
                                                            attrs: {
                                                              for: "invoice-data-sales-person",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Sales Person:"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "validation-provider",
                                                          {
                                                            attrs: {
                                                              rules: "required",
                                                              name: "Sales Person",
                                                              vid: "Sales Person",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var errors =
                                                                      ref.errors
                                                                    return [
                                                                      _c(
                                                                        "b-form-select",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              options:
                                                                                _vm.optionsSalesPerson,
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm.salesPersonId,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.salesPersonId =
                                                                                    $$v
                                                                                },
                                                                              expression:
                                                                                "salesPersonId",
                                                                            },
                                                                        }
                                                                      ),
                                                                      errors.length
                                                                        ? _c(
                                                                            "small",
                                                                            {
                                                                              staticClass:
                                                                                "text-danger",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  errors[0]
                                                                                )
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "b-col",
                                                  {
                                                    staticClass:
                                                      "mt-md-6 d-flex justify-content-end",
                                                    attrs: {
                                                      cols: "12",
                                                      md: "8",
                                                      order: "1",
                                                      "order-md": "2",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "invoice-total-wrapper",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "invoice-total-item",
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "invoice-total-title",
                                                              },
                                                              [_vm._v("Total:")]
                                                            ),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "invoice-total-amount",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.finalTotal
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("hr", {
                                          staticClass: "invoice-spacing",
                                        }),
                                        _c(
                                          "b-card-body",
                                          {
                                            staticClass: "invoice-padding pt-0",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "font-weight-bold",
                                              },
                                              [_vm._v("Note: ")]
                                            ),
                                            _c("b-form-textarea", {
                                              staticClass:
                                                "form-control invoice-edit-input",
                                              model: {
                                                value: _vm.note,
                                                callback: function ($$v) {
                                                  _vm.note = $$v
                                                },
                                                expression: "note",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        842532495
                      ),
                    }),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  {
                    staticClass: "invoice-actions",
                    attrs: { cols: "12", md: "4", xl: "3" },
                  },
                  [
                    _c(
                      "b-card",
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "mb-75",
                            style: _vm.loadingButton
                              ? { cursor: "not-allowed" }
                              : {},
                            attrs: {
                              variant: "outline-primary",
                              block: "",
                              disabled: _vm.loadingButton,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.addSalesOrder()
                              },
                            },
                          },
                          [_vm._v(" Save ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }